var map = {
	"./article.svg": "dfb6",
	"./exercise-routine.svg": "dc2a",
	"./goal.svg": "c34c",
	"./mental-health.svg": "b58c",
	"./no-medication.svg": "2398",
	"./no-pain.svg": "f927",
	"./no-surgery.svg": "fbc2",
	"./shield-alt.svg": "4d53",
	"./sleep.svg": "3cb7",
	"./strength.svg": "0c1b",
	"./target.svg": "258c",
	"./tennis.svg": "a027"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8bd6";